export const ABRIR_ASISTENTE = "nuvlipro:abrir-asistente";

export const abrirAsistente = () => window.dispatchEvent(new Event(ABRIR_ASISTENTE));
